import { clinicHealthAdapter, HealthStatusPage } from '@pa/staff'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

/** C-12's search params (Frontend §6.1): `page` for the incident history. */
interface StatusSearch {
  page?: number
}

/**
 * C-12 System status (UserFlows C-12; Frontend §6.1, §6.3): the shared `@pa/staff` `health` feature over the clinic
 * adapter (#29, #30). Times in the clinic's zone.
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/status')({
  validateSearch: (raw: Record<string, unknown>): StatusSearch => {
    const page = Number(raw.page)
    return Number.isInteger(page) && page > 1 ? { page } : {}
  },
  component: function StatusRoute() {
    const { clinicId } = Route.useParams()
    const { timeZone } = Route.useRouteContext()
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const adapter = useMemo(() => clinicHealthAdapter(clinicId), [clinicId])
    return (
      <HealthStatusPage
        adapter={adapter}
        timeZone={timeZone}
        page={search.page ?? 1}
        onPage={(page) => {
          void navigate({ search: page > 1 ? { page } : {} })
        }}
      />
    )
  },
})
